module.exports = __webpack_public_path__ + "img/product_img_bg.1bbc5a3.webp";